import { format, toZonedTime } from "date-fns-tz";

const Format = Object.freeze({
  date_format: 'MM/dd/yyyy',
  date_time_format: 'MM/dd/yyyy HH:mm',
  date_time_report_format: 'yyyy-MM-dd HH:mm:ss',
  time_format: 'HH:mm'
});

export default Format;

/**
 *
 * @param datetime: String
 * @returns DateTime
 */
export function formatDateTime(datetime) {
  const dt = new Date(datetime);
  const d= format(toZonedTime(dt, "UTC"), Format.date_time_format, { timeZone: "UTC"});
  return d;
}

/**
 *
 * @param datetime: String
 * @returns DateTime
 */
export function formatDateTimeNoTimeZoneForReport(datetime) {
  const dt = new Date(datetime);
  const d = format(dt, Format.date_time_report_format);
  return d;
}

/**
 *
 * @param datetime: String
 * @returns Time
 */
export function formatTime(datetime) {
  const dt = new Date(datetime);
  return format(toZonedTime(dt, "UTC"), Format.time_format, { timeZone: "UTC"});
}

/**
 *
 * @param datetime: String
 * @returns Date
 */
export function formatDate(datetime) {
  const dt = new Date(datetime);
  return format(toZonedTime(dt, "UTC"), Format.date_format, { timeZone: "UTC"});
}

export function formatDateTimeET(datetime) {
      if (datetime) {
        return format(toZonedTime(datetime, "America/Toronto"), 'yyyy-MM-dd HH:mm', { timeZone: "UTC"});
      }
  }

export function formatDateTimeWithSecondsET(datetime) {
  if (datetime) {
    return format(toZonedTime(datetime, "America/Toronto"), 'yyyy-MM-dd HH:mm:ss', { timeZone: "UTC"});
  }
}

/**
 *
 * @param datetime: String
 * @returns Date
 */
export function formatDateTimeTotoLocaleString(dateString) {
  const date = new Date(dateString);
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
}

/**
 *
 * @param height: number
 * @returns number
 */
export function convertCmToInch(height){
  if(height) {
      return (height * 0.39370).toFixed(1);
  }
  return '';
}

/**
 *
 * @param height: number
 * @returns number
 */
export function convertKgToLbs(weight){
  if(weight) {
      return (weight * 2.2046).toFixed(1);
  }
  return '';
}

/**
 *
 * @param datetime: String
 * @returns string
 */
export function timeFromDate(date) {
  let daysCalc = 1000 * 60 * 60 * 24
  let milliseconds = new Date() - new Date(date)
  let days = Math.floor(milliseconds / daysCalc);
  milliseconds -= days * daysCalc

  let hours = Math.floor(milliseconds / (daysCalc / 24));
  milliseconds -= hours * (daysCalc / 24)

  let minutes = Math.floor(milliseconds / (daysCalc / (24 * 60)));
  milliseconds -= minutes * (daysCalc / (24 * 60))

  let seconds = Math.floor(milliseconds / (daysCalc / (24 * 60 * 60)));

  return `${days > 0 ? `${days}d, ` : ''}${hours > 0 ? `${hours}h, ` : ''}${minutes > 0 ? `${minutes}m, ` : ''}${seconds > 0 ? `${seconds}s` : ''}`
}

